import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ReminderPopup from "@/components/ReminderPopup";
import Preloader from "@/components/Preloader";
import Hero from "@/sections/Hero";
import HighlightMarquee from "@/sections/HighlightMarquee";
import WhyKazakhstan from "@/sections/WhyKazakhstan";
import Departments from "@/sections/Departments";
import Universities from "@/sections/Universities";
import HowItWorks from "@/sections/HowItWorks";
import Documents from "@/sections/Documents";
import Services from "@/sections/Services";
import Testimonials from "@/sections/Testimonials";
import ApplicationForm from "@/sections/ApplicationForm";
import Faq from "@/sections/Faq";
import Contact from "@/sections/Contact";

export default function Landing() {
  return (
    <SmoothScroll>
      <Preloader />
      <div className="grain" aria-hidden />
      <Navbar />
      <main>
        <Hero />
        <HighlightMarquee />
        <WhyKazakhstan />
        <Departments />
        <Universities />
        <HowItWorks />
        <Documents />
        <Services />
        <Testimonials />
        <ApplicationForm />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <ReminderPopup />
    </SmoothScroll>
  );
}
